export default __webpack_public_path__ + "static/media/2251.f30a5b5e.svg";